import React from 'react';
const legalLinks = [{
  label: 'Regulamin',
  href: '#regulamin'
}, {
  label: 'Polityka prywatności',
  href: '#polityka-prywatnosci'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}];
export function Footer() {
  return <footer className="w-full bg-background px-5 py-10" data-id="element-108" data-mp="32p5naics70pu">
      <div className="mx-auto max-w-2xl text-center" data-id="element-109" data-mp="36p6df098t0cq">
        <p className="font-display text-base font-bold text-foreground" data-id="element-110" data-mp="36pz9966ny5g3">
          PRACOWNIA MAŁEGO WYNALAZCY
        </p>
        <p className="mt-2 text-xs leading-relaxed text-foreground/60" data-id="element-111" data-mp="3ucxsgbm63rhp">
          Biblioteka projektów STEM do wydrukowania dla ciekawskich dzieci w wieku 5–12 lat.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-foreground/50" data-id="element-112" data-mp="3ldu34pweqfur">
          Produkt cyfrowy · Nie wysyłamy fizycznego zestawu · Płatność jednorazowa · Bez
          subskrypcji.
          <br data-id="element-113" data-mp="29ydvry6nv08u" />
          Do użytku osobistego, domowego i w jednej klasie. Rozpowszechnianie i odsprzedaż są
          zabronione.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-foreground/45" data-id="element-114" data-mp="2evxb71f3hj2d">
          Każda karta zawiera wskazówki bezpieczeństwa. Tam, gdzie to zaznaczono, zalecamy nadzór
          osoby dorosłej.
        </p>
        <nav aria-label="Informacje prawne" className="mt-4" data-id="element-115" data-mp="3v7q6vs7ueph3">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 text-xs text-foreground/60" data-id="element-116" data-mp="3v919hopjxr6m">
            {legalLinks.map((link, i) => <li key={link.label} className="flex items-center gap-2" data-id="element-117" data-mp="82idvwen2ggf" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" data-id="element-118" data-mp="33xchtnnhqqe">·</span>}
                <a href={link.href} className="underline-offset-2 transition-colors duration-150 ease-out hover:text-foreground hover:underline" data-id="element-119" data-mp="335tdib8plh0">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-4 text-xs text-foreground/45" data-id="element-120" data-mp="qu1drudd9ee8">© 2026 Pracownia Małego Wynalazcy.</p>
      </div>
    </footer>;
}